/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import { AppointmentTypeSelectionList, DuplicateAccountAlertCard, Loading, OutstandingPaymentCardList } from "../../components";
import { CREATE_BOOKING_TYPE, MODALS, WELLNESS_PLAN_STATUSES } from "../../config/params";
import React, { FC, useEffect, useMemo, useRef, useState } from "react";

import AppointmentCardList from "../../components/Appointments/AppointmentCardList";
import { BoldSubHeaderText } from "../../styles/styledComponents/Header.styled";
import { Box } from "@mui/material";
import { MIXPANEL_EVENTS } from "../../config/mixPanelEvents";
import { PAGES_PATH } from "../../navigation/params";
import PetContainer from "./components/PetContainer";
import ReviewUpsellCard from "./components/ReviewUpsellCard";
import RightPanelContainer from "./components/RightPanelContainer";
import SocReminderContainer from "./components/SocReminderContainer";
import UpdatedBookingModule from "../../components/UpdatedBookingModule/UpdatedBookingModule";
import PrequalContinuationCard from "../../components/Prequalification/PrequalContinuationCard";
import PrequalDashboardCard from "../../components/Prequalification/PrequalDashboardCard";
import { usePrequalContinuationRecord } from "../../hooks/usePrequalContinuationRecord";
import { appointmentActions } from "../../state/bookedAppointments";
import { createDate } from "../../utils/date";
import { useWellnessFunnel } from "../../hooks/useWellnessFunnel";
import { socStatusMapper } from "../../utils/SOCUtils";
import { useAppointmentStore } from "../../hooks/redux-hooks/appointment-store/appointment.store";
import { useDashboard } from "../../services/dashboard/dashboard.service";
import { useDispatch } from "react-redux";
import { useHospitalOpenCheck } from "../../hooks/useHospitalOpenCheck";
import { useModal } from "../../context/ModalContext";
import { useLocation, useNavigate } from "react-router-dom";
import { usePetStore } from "../../hooks/redux-hooks/pet-store/pet-store.service";
import { useUserCreateStore } from "../../hooks/redux-hooks/user-create-store/user-create.store";
import { useUserDetail } from "../../services/user-detail/user-detail.service";
import useWebsiteBookingStatus from "../../services/website-user-status/website-booking-status.service";
import useWellnessPlansByUser from "../../services/wellness-plans-by-user/wellness-plan-by-user.service";
import { userActivityLogger } from "../../utils/mixpanel";
import { IWellnessPlanByUser } from "../../services/wellness-plans-by-user/wellness-plan-by-user.interface";
import useContentfulDataStore from "../../hooks/redux-hooks/contentful-data-store/contentful-data.store";
import { ILocationContentfulData } from "../../services/contentful-service/contentful.interface";
import { getLocationDetails } from "../../services/contentful-service/contentfulClient.service";
import { useOverdueInvoiceStore } from "../../hooks/redux-hooks/overdue-invoice-store/overdue-invoice.store";
import DropOffCard from "../../components/DropOffCard/DropOffCard";
import { useAllServiceStatusStore, useBookingAppointmentTypeStore, useCombinedAlertsDataStore } from "../../hooks";
import { InfoIcon } from "../../components/Icons";
import WellnessRenewalUnsuccessfulCard from "../../shared/modals/WellnessRenewalAlerts/WellnessRenewalUnsuccessfulCard";
import { getEpochForTimeZone, isWithinPast3Days } from "../../utils/unix-timestamp";
import useWellnessModalStatusStore from "../../hooks/redux-hooks/wellness-modal-status-store/wellness-modal-status-store";
import WellnessRenewalDashboardCard from "../../components/WellnessPlan/WellnessRenewalDashboardCard";
import CarouselScratchPayRenewalCard from "../../components/WellnessPlan/CarouselScratchPayRenewalCard";
import WellnessDetailsPlanCard from "../../components/WellnessPlan/WellnessDetailsPlanCard";


const Dashboard: FC = () => {
  const { data: webUserStatusData, getWebUserStatus } = useWebsiteBookingStatus();
  const { setCreateProfile } = useUserCreateStore();
  const navigate = useNavigate();
  const { user, loading: getProfileLoading } = useUserDetail();
  const { getDashBoardData, dashboard } = useDashboard();
  const { openModal, modalView } = useModal();
  // const { cardList } = useCardList();
  const { showWellnessUpsell } = useWellnessModalStatusStore();

  const { getWellnessPlansByUser, data, loading: wellnessPlanDataLoading } = useWellnessPlansByUser();
  const [hospitalDetailsContentful, setHospitalDetailsContentful] = useState<any>(null);
  const [outstandingPaymentData, setOutstandingPaymentData] = useState<IWellnessPlanByUser[]>([]);
  const [isDuplicateCardShown, setIsDuplicateCardShown] = useState<boolean>(false);
  const { isWellnessServiceAvailable, isUrgentCareOnly }=useAllServiceStatusStore();
  const { petList }=usePetStore();

  // Cross-reference dashboard pets with the trusted petList (kept fresh by
  // DrawerGeneric's usePetList / GET_ALL_PETS). The DASHBOARD backend resolver
  // may still include a just-retired pet due to eventual consistency, so we
  // filter it out on the client side.
  const dashboardPets = useMemo(() => {
    if (!dashboard?.pets) return dashboard?.pets;
    if (!petList?.length) return dashboard.pets;
    const activePetIds = new Set(petList.map((p) => p.id));
    return dashboard.pets.filter((pet) => activePetIds.has(pet.id));
  }, [dashboard?.pets, petList]);
  const { setContentfulData }=useContentfulDataStore();
  const { setCancelledPetList, setPausedPetList, setPendingPaymentPetList, setIsOverdueStoreUpdated, pausedWellnessPetList, cancelledWellnessPetList, pendingPaymentPetList, setCancelledPetListWithoutOverdue, setScratchpayOverdueNoticePetIds }=useOverdueInvoiceStore();
  const redirectionPath = localStorage.getItem("redirectionPath");
  const { bookingAppointmentType } = useBookingAppointmentTypeStore();
  const {
    shouldShowPrequalification,
    failedRenewalsWithGracePeriodWPData,
    endsSoonWPData,
    scratchpayRenewalPending,
  } = useCombinedAlertsDataStore();
  const modelOpenCount = useRef(0);
  const openCount = useRef(0);
  const hasRedirectedRef = useRef(false);
  const dispatch = useDispatch();
  const location = useLocation();

  const isNotAnExistingUserFromEzyVet = () => {
    if (location.state?.existingUserFromEzyVet) {
      return false;
    }

    return true;
  };

  useEffect(() => {
    if (user) {
      if (user.contact_id === "" || !user.contact_id || ((!user.phone && !user.fireBasePhone))) {
        setCreateProfile(null);
        if ((!user.phone && !user.fireBasePhone)) {
          navigate(PAGES_PATH.ADD_PHONE_NUMBER);
        } else {
          navigate(PAGES_PATH.PROFILE_COMPLETION);
        }
      } else {
        getDashBoardData();
        getWellnessPlansByUser();
        if (user.location) {
          getLocationDetails(user.location.locationName)
            .then((hospitalDetails: ILocationContentfulData | null) => {
              setContentfulData(hospitalDetails);
            });
          userActivityLogger(MIXPANEL_EVENTS.USER_LANDS_ON_DASHBOARD, {
            location: user.location.locationName,
            msa: user.location.city,
          });
        }
      }
    }
  }, [user]);

  useEffect(() => {
    if (data) {
      if (data.length > 0) {
        const pendingPaymentData=data.filter((petData) => {
          const status = petData.wellnessPlanPaymentStatus.toLowerCase();

          return !petData.isScratchpay && (
            ((status === WELLNESS_PLAN_STATUSES.PAUSED ||
                    status === WELLNESS_PLAN_STATUSES.LOCKED)) ||
                    status === WELLNESS_PLAN_STATUSES.CANCELLED && (petData.pendingEzyvetInvoices !== null));
        });
        const pendingPaymentWithoutUnsuccessfulData=data.filter((petData) => {
          const status = petData.wellnessPlanPaymentStatus.toLowerCase();
          const isScratchpayLocked =
            Boolean(petData.isScratchpay) &&
            petData.wellnessPlanDetails?.status?.toLowerCase() === WELLNESS_PLAN_STATUSES.LOCKED;

          return ((status === WELLNESS_PLAN_STATUSES.PAUSED ||
                    status === WELLNESS_PLAN_STATUSES.LOCKED) &&
                  !(petData.wellnessPlanDetails?.renewalStatus && isWithinPast3Days(petData.wellnessPlanDetails?.startDate))) ||
                    isScratchpayLocked ||
                    (petData.isScratchpay && petData.isOverdue) ||
                    status === WELLNESS_PLAN_STATUSES.CANCELLED && (petData.pendingEzyvetInvoices !== null);
        });
        const pausedPetList = data.filter(
          (petData) =>
            (petData.wellnessPlanPaymentStatus.toLowerCase() === WELLNESS_PLAN_STATUSES.PAUSED ||
            petData.wellnessPlanPaymentStatus.toLowerCase() === WELLNESS_PLAN_STATUSES.LOCKED) &&
            (petData.pendingSquareInvoices.length > 0),
        ).map((filteredData)=>({ petId: filteredData.pet.id, petName: filteredData.pet.name,
          publicUrl: filteredData.pendingSquareInvoices[0]?.publicUrl, dueAmount: filteredData.pendingSquareInvoices[0]?.amount,
          invoiceDueDate: filteredData.pendingSquareInvoices[0]?.dueDate, planName: filteredData.wellnessPlan?.wellnessplanName }));
        const cancelledPetList = data.filter((petData) => (petData.wellnessPlanPaymentStatus.toLowerCase() === WELLNESS_PLAN_STATUSES.CANCELLED) && (petData.pendingEzyvetInvoices !== null)).
          map((filteredData)=>({ petId: filteredData.pet.id, petName: filteredData.pet.name, planName: filteredData.wellnessPlan?.wellnessplanName }));

        setOutstandingPaymentData(pendingPaymentWithoutUnsuccessfulData);
        setCancelledPetList(cancelledPetList);
        setPausedPetList(pausedPetList);
        setPendingPaymentPetList(pendingPaymentData.map((filteredData)=>({
          petId: filteredData.pet.id,
          petName: filteredData.pet.name,
          endDate: filteredData.wellnessPlanDetails?.endDate,
          wellnessPlanPaymentStatus: filteredData.wellnessPlanPaymentStatus,
          petImage: filteredData.pet.image ?? undefined,
          pendingInvoices: filteredData.pendingSquareInvoices.length,
          dueAmount: filteredData.pendingSquareInvoices[0]?.amount,
          invoiceDueDate: filteredData.pendingSquareInvoices[0]?.dueDate,
          publicUrl: filteredData.pendingSquareInvoices[0]?.publicUrl })));

        const scratchpayOverdueNoticePetIds = data
          .filter((petData) => Boolean(petData.isScratchpay) && Boolean(petData.isOverdue))
          .map((petData) => String(petData.pet.id));
        setScratchpayOverdueNoticePetIds(scratchpayOverdueNoticePetIds);

        // To Update the soc overdue icon in profile card when only cancelled pet list is present without overdue
        const cancelledPetListWithoutOverdue = data.filter((petData) => {
          const status = petData.wellnessPlanPaymentStatus.toLowerCase();
          return status === WELLNESS_PLAN_STATUSES.CANCELLED ||
            status === WELLNESS_PLAN_STATUSES.PAUSED ||
            status === WELLNESS_PLAN_STATUSES.LOCKED;
        }).map((filteredData)=>({ petId: filteredData.pet.id, petName: filteredData.pet.name, planName: filteredData.wellnessPlan?.wellnessplanName }));

        setCancelledPetListWithoutOverdue(cancelledPetListWithoutOverdue);
      }
    }
  }, [data]);

  useEffect(()=>{
    if (data && webUserStatusData?.isWebUser && !modalView) {
      if (modelOpenCount.current > 0) return;
      if (webUserStatusData?.nextScreen === "bookAVisit") {
        userActivityLogger(MIXPANEL_EVENTS.BOOK_A_VISIT, { start_from: "website_flow", appt_type: bookingAppointmentType === CREATE_BOOKING_TYPE.DROPOFF_BOOKING ? "drop_off" : "in_room_visit",
          overdue_status: pendingPaymentPetList.length > 0 ? "yes" : "no",
          is_plan_cancelled: cancelledWellnessPetList.length > 0 ? "true" : "false",
        });
        if (cancelledWellnessPetList.length > 0) {
          userActivityLogger(MIXPANEL_EVENTS.DELINQUENCY_BOOKING_BLOCKED, {
            delinquency_state: "cancelled",
            entry_point: "dashboard",
            num_affected_pets: pendingPaymentPetList.length,
          });
          openModal(MODALS.PENDING_INVOICE_CANCELLED_ALERT_MODAL);
        } else if (pausedWellnessPetList.length > 0) {
          userActivityLogger(MIXPANEL_EVENTS.DELINQUENCY_BOOKING_BLOCKED, {
            delinquency_state: "paused",
            entry_point: "dashboard",
            num_affected_pets: pendingPaymentPetList.length,
          });
          openModal(MODALS.PENDING_INVOICE_PAUSED_ALERT_MODAL);
        } else {
          openModal(MODALS.UPDATED_BOOK_A_VISIT_MODAL);
        }
      } else {
        openModal(MODALS.MSA_CHANGE_MODAL);
      }
      modelOpenCount.current++;
    };
  }, [webUserStatusData, modalView, data]);

  useEffect(()=>{
    if (!wellnessPlanDataLoading) {
      setIsOverdueStoreUpdated(true);
    } else {
      setIsOverdueStoreUpdated(false);
    }
  }, [wellnessPlanDataLoading]);

  useEffect(()=>{
    if (dashboard) {
      if (dashboard?.pastAppointments?.length > 0) {
        dispatch(appointmentActions.setPastAppointments(dashboard.pastAppointments));
      }
    }
  }, [dashboard]);


  const petsWithAppointment: string[] = useMemo(() => {
    if (dashboard && dashboard.appointments && dashboard.appointments.length) {
      return dashboard?.appointments.map((appointment) => {
        return appointment.pet.id;
      });
    } else {
      return [];
    }
  }, [dashboard?.appointments]);

  const overduePetsIds: string[] = useMemo(() => {
    if (dashboardPets && dashboardPets.length) {
      const overDuePets: string[] = [];

      dashboardPets.map((pet) => {
        if ((pet.socStatus == socStatusMapper.overdue || pet.socStatus == socStatusMapper.incomplete) &&
          !petsWithAppointment.includes(pet.id)
        ) {
          overDuePets.push(pet.id);
        };
      });

      return overDuePets;
    } else {
      return [];
    }
  }, [dashboardPets]);

  useEffect(()=>{
    if (hasRedirectedRef.current || !redirectionPath) return;
    // Wait for GET_PROFILE to settle before navigating away: this effect runs
    // on mount, and redirecting immediately unmounts Dashboard (the only page
    // fetching the profile on this path), aborting the request so redux `user`
    // never populates. Deep-link targets like the wellness payment page gate
    // their header on `user`, so leaving early clips their layout. Gate on
    // loading (not `user`) so an errored profile fetch still redirects.
    if (getProfileLoading) return;

    hasRedirectedRef.current = true;
    localStorage.removeItem("redirectionPath");
    navigate(redirectionPath);
  }, [getProfileLoading, redirectionPath, navigate]);

  const handlePastVisits = () => {
    if (petList && petList.length === 1) {
      navigate(`/pet-care?id=${petList[0].id}&category=Health_Records`);
    } else {
      openModal(MODALS.SELECT_PET_MODAL);
    }
  };

  useEffect(() => {
    const isWebUserApiCalled = localStorage.getItem("isWebUserApiCalled");

    if (isWebUserApiCalled !== "true") {
      getWebUserStatus();
      localStorage.setItem("isWebUserApiCalled", "true");
    };
    localStorage.setItem("isWebUser", JSON.stringify(webUserStatusData));
  }, [webUserStatusData]);


  const setHospitalDetailsContent = (hospitalDetails: any) => {
    setHospitalDetailsContentful(hospitalDetails);
  };

  // Website and QR redirection flow code
  const isWebUserWellnessRedirect = JSON.parse(localStorage.getItem("wellness-utm") || "{}");

  const wellnessFunnel = useWellnessFunnel({ source: "upsells" });
  const prequalContinuation = usePrequalContinuationRecord();

  const handleSubscribeClick = () => {
    if (dashboardPets && dashboardPets.length > 1 && openCount.current === 0) {
      if (cancelledWellnessPetList.length > 0) {
        userActivityLogger(MIXPANEL_EVENTS.DELINQUENCY_BOOKING_BLOCKED, {
          delinquency_state: "cancelled",
          entry_point: "subscribe_cta",
          num_affected_pets: pendingPaymentPetList.length,
        });
        openModal(MODALS.PENDING_INVOICE_CANCELLED_ALERT_MODAL);
        openCount.current++;
        return;
      }
      if (pausedWellnessPetList.length > 0) {
        userActivityLogger(MIXPANEL_EVENTS.DELINQUENCY_BOOKING_BLOCKED, {
          delinquency_state: "paused",
          entry_point: "subscribe_cta",
          num_affected_pets: pendingPaymentPetList.length,
        });
        openModal(MODALS.PENDING_INVOICE_PAUSED_ALERT_MODAL);
        openCount.current++;
        return;
      }
      openCount.current++;
    }

    wellnessFunnel.start();
  };

  const handleExpressInfoClick = ()=>{
    openModal(MODALS.EXPRESS_VISIT_INFO_MODAL);
  };

  const getDashboardCard = () => {
    if (scratchpayRenewalPending && scratchpayRenewalPending.length > 0) {
      return <CarouselScratchPayRenewalCard renewalData={scratchpayRenewalPending} />;
    } else if (endsSoonWPData && endsSoonWPData.length > 0) {
      return <WellnessRenewalDashboardCard />;
    } else if (
      isWellnessServiceAvailable &&
      prequalContinuation.record &&
      prequalContinuation.pet &&
      !prequalContinuation.dismissed
    ) {
      // SGPD-475: purchase continuation outranks the check-eligibility invite;
      // the two are also mutually exclusive server-side (a valid record turns
      // shouldShowPrequalification off).
      return (
        <PrequalContinuationCard
          record={prequalContinuation.record}
          pet={prequalContinuation.pet}
          onDismiss={prequalContinuation.dismiss}
        />
      );
    } else if (isWellnessServiceAvailable && shouldShowPrequalification) {
      return <PrequalDashboardCard />;
    }
    return null;
  };

  useEffect(() => {
    if (dashboardPets?.length && isWebUserWellnessRedirect.isWellnessPageRedirect && modalView !== MODALS.UPDATED_BOOK_A_VISIT_MODAL) {
      if (hospitalDetailsContentful && (Object?.keys(hospitalDetailsContentful).length)) {
        const openingHospitalDate = createDate(hospitalDetailsContentful.fields.openingDay as number,
          hospitalDetailsContentful.fields.openingMonth as number, hospitalDetailsContentful.fields.openingYear as number);

        !isUrgentCareOnly && isWellnessServiceAvailable && handleSubscribeClick();
      }
    };
  }, [dashboardPets, isWebUserWellnessRedirect.isWellnessPageRedirect, hospitalDetailsContentful]);


  if (getProfileLoading || wellnessPlanDataLoading) {
    return <div className="w-full h-full flex flex-col justify-center items-center">
      <img src="/assets/icons/Foxhound_Loading.gif" className="w-96" />
      <div className="font-semibold text-xl">Hang tight, gathering your information...</div>
    </div>;
  }

  return (
    <>
      {(user && user.location && user.location.idLocation || getProfileLoading) ? (
        <div className="flex flex-row md:gap-10 desktop:gap-20 flex-1 !lg:justify-center">
          {/* Figma dashboard geometry: 528px column + 80px gutter + 320px
              rail + 32px section gaps, engaged at 1200px together with the
              shell's 80px page margin (layoutContentStyle) so left and right
              spacing around the column always match. Below 1200px nothing
              changes. */}
          <div
            className="flex flex-col gap-2 lg:gap-8 min-w-0 md:max-w-lg lg:max-w-2xl
            desktop:max-w-[528px]"
          >
            {user?.isDuplicateAccount &&
            <DuplicateAccountAlertCard
              isDuplicateCardShown={isDuplicateCardShown}
              setIsDuplicateCardShown={setIsDuplicateCardShown} />}
            {/* Dashboard card */}
            {getDashboardCard()}
            {dashboard?.pastAppointments?.length ?
              dashboard.pastAppointments.filter((appointment) => appointment.underFeedbackDays &&
               appointment.feedback.length==0).map(
                (appointment) => {
                  return (
                    <ReviewUpsellCard key={appointment.id} appointmentData={appointment}/>
                  );
                },
              ): null }

            {failedRenewalsWithGracePeriodWPData.length > 0 &&
            failedRenewalsWithGracePeriodWPData.map((petData, index)=>(
              <WellnessRenewalUnsuccessfulCard
                key={index}
                currentDate={getEpochForTimeZone()}
                startDate={parseInt(petData.startDate, 10)}
                petImage={petData?.petImage ?? undefined}
                petName={petData.petName}
                petId={petData.petId}
                planName={petData?.wellnessPlanName}
                isScratchpay={petData?.isScratchpay}
              />
            ))}

            {outstandingPaymentData.length > 0 &&
              <OutstandingPaymentCardList outstandingPaymentData={outstandingPaymentData} />

            }

            {dashboard?.appointments && dashboard?.appointments.length > 0 ? (
              <Box className="flex justify-between">
                <BoldSubHeaderText className="!mt-1"> Appointments</BoldSubHeaderText>
                <div
                  onClick={handlePastVisits}
                  className="cursor-pointer font-semibold text-sm mt-1.5 text-gray-1"
                >
                  Past Visits
                </div>
              </Box>
            ) : null}

            {dashboard?.appointments?.length ?
              <AppointmentCardList appointments={dashboard?.appointments} />: null}
            {!modalView &&
              <div className="w-full max-w-inherit">
                <UpdatedBookingModule />
              </div>}

            {/* other services box start */}

            <div>
              <Box className="flex justify-between">
                <BoldSubHeaderText className="!mt-1"> Other Services</BoldSubHeaderText>
                <div
                  onClick={handleExpressInfoClick}
                  className="cursor-pointer font-semibold text-sm mt-2 text-gray-1"
                >
                  <InfoIcon width={18} height={18} />
                </div>
              </Box>
              <div className="my-3 w-full">
                <AppointmentTypeSelectionList />
              </div>
            </div>
            {/* other services box end */}

            {
              overduePetsIds.length >= 1 && <SocReminderContainer petIds={overduePetsIds} />
            }
            {dashboardPets && dashboardPets.length > 0 && <PetContainer pets={dashboardPets} />}
          </div>
          <Box
            className="hidden h-full md:flex flex-col gap-10 max-w-[15.625rem]
            lg:max-w-[23.125rem] desktop:max-w-[320px]"
          >
            <RightPanelContainer setHospitalDetailsContent={setHospitalDetailsContent} />
          </Box>
        </div>
      ) : (
        <Box className="flex h-full w-full justify-center items-center">
          <Loading />
        </Box>
      )}
    </ >
  );
};

export default Dashboard;


